export default __webpack_public_path__ + "static/media/login-screen.6831608d.png";